// extracted by mini-css-extract-plugin
export var button = "_5h-7";
export var buttonRow = "_5h-6";
export var fadeIn = "_5h-1";
export var gradient = "_5h-0";
export var panel = "_5h-2";
export var panelIn = "_5h-3";
export var subtitle = "_5h-5";
export var title = "_5h-4";